export const UUI_FILTERS_PANEL_ADD_BUTTON = 'uui-filters-panel-add-button';
export const UUI_FILTERS_PANEL_ADD_BUTTON_BODY = 'uui-filters-panel-add-button-body';
export const UUI_FILTERS_PANEL_ITEM_BODY = 'uui-filters-panel-item-body';
export const UUI_FILTERS_PANEL_ITEM_TOGGLER = 'uui-filters-panel-item-toggler';
